import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../components/admin/BoxTitle";
import {ApiService} from "../../service/ApiService";
import {dashboardResultType} from "../../types/Api/DashboardResultType";

export const Dashboard = () => {
  const [data, setData] = useState(undefined as undefined | dashboardResultType);

  useEffect(() => {
    const result = ApiService.get(`/_/dashboard`) as Promise<dashboardResultType>
    result.then((r) => setData(r));
  }, []);

  return (
    <>
      <BoxTitle title="Bienvenue dans la partie Administration du C’Team Chartres"/>

      <div className="d-flex flex-wrap">
        {data?.user && (
          <div className="w400px p-1">
            <div className={`__admin_dashboard_card__ card shadow-sm h-100`}>
              <div className="card-body h-100">
                <div className="d-flex flex-row align-items-center h-100">
                  <div className="font-1_95 ms-2 me-4 __admin_dashboard_card_icon__">
                    <i className="fa-solid fa-user-secret"/>
                  </div>
                  <div className="">
                    <p>
                      <h5 className="card-title me-2">Utilisateurs</h5>
                      <span className="badge bg-success">{data.user.enabled}</span> actif<br/>
                      <span className="badge bg-warning">{data.user.disabled}</span> inactif<br/>
                      <span className="badge bg-info">{data.user.unverified}</span> en cours de validation<br/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {data?.news && (
          <div className="w400px p-1">
            <div className={`__admin_dashboard_card__ card shadow-sm h-100`}>
              <div className="card-body h-100">
                <div className="d-flex flex-row align-items-center h-100">
                  <div className="font-1_95 ms-2 me-4 __admin_dashboard_card_icon__">
                    <i className="fa-solid fa-circle-info"/>
                  </div>
                  <div className="">
                    <p>
                      <h5 className="card-title me-2">Actualités</h5>
                      <span className="badge bg-success">{data.news.enabled}</span> active<br/>
                      <span className="badge bg-warning">{data.news.disabled}</span> inactive<br/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {data?.route && (
          <div className="w400px p-1">
            <div className={`__admin_dashboard_card__ card shadow-sm h-100`}>
              <div className="card-body h-100">
                <div className="d-flex flex-row align-items-center h-100">
                  <div className="font-1_95 ms-2 me-4 __admin_dashboard_card_icon__">
                    <i className="fa-solid fa-person-biking"/>
                  </div>
                  <div className="">
                    <p>
                      <h5 className="card-title me-2">Parcours</h5>
                      <p className="m-0 mb-1"><span className="badge bg-success">{data.route.scheduled}</span> programmés</p>
                      <p className="m-0">Prochaine sortie : <span className="bold">{data.route.next}</span></p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {data?.office && (
          <div className="w400px p-1">
            <div className={`__admin_dashboard_card__ card shadow-sm h-100`}>
              <div className="card-body h-100">
                <div className="d-flex flex-row align-items-center h-100">
                  <div className="font-1_95 ms-2 me-4 __admin_dashboard_card_icon__">
                    <i className="fa-solid fa-users-line"/>
                  </div>
                  <div className="">
                    <p>
                      <h5 className="card-title me-2">Bureau</h5>
                      <h6 className="card-title me-2">{data.office.label}</h6>
                      <span className="badge bg-success">{data.office.total}</span> postes<br/>
                      <span className="badge bg-warning">{data.office.total - data.office.completed}</span> a compléter<br/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {data?.partner && (
          <div className="w400px p-1">
            <div className={`__admin_dashboard_card__ card shadow-sm h-100`}>
              <div className="card-body h-100">
                <div className="d-flex flex-row align-items-center h-100">
                  <div className="font-1_95 ms-2 me-4 __admin_dashboard_card_icon__">
                    <i className="fa-solid fa-handshake"/>
                  </div>
                  <div className="">
                    <p>
                      <h5 className="card-title me-2">Partenaires</h5>
                      <span className="badge bg-success">{data.partner.enabled}</span> actif<br/>
                      <span className="badge bg-warning">{data.partner.disabled}</span> inactif<br/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}
